import React from 'react';
import { Box, Checkbox, TextField, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { IConfigurationIdEntry } from '../../../models/configuration/plugin/IConfiguration';
import DtAlert from '../../ui/alert/DtAlert';
import { DtCard } from '../../ui/card';

interface ConfigurationIdsTabProps {
    configurationIds: IConfigurationIdEntry[];
    updateConfigurationIds: (entries: IConfigurationIdEntry[]) => void;
}

const ConfigurationIdsTab: React.FC<ConfigurationIdsTabProps> = ({ configurationIds, updateConfigurationIds }) => {
    const handleAliasChange = (index: number, alias: string) => {
        const updated = configurationIds.map((e, i) =>
            i === index ? { ...e, Alias: alias } : e
        );
        updateConfigurationIds(updated);
    };

    const handleEnabledToggle = (index: number) => {
        const updated = configurationIds.map((e, i) =>
            i === index ? { ...e, Enabled: !e.Enabled } : e
        );
        updateConfigurationIds(updated);
    };

    return (
        <DtCard
            header="Choose Configuration IDs to Display"
            variant="outlined"
            contentContainerSx={{ pb: 2 }}
            sx={{ maxWidth: 640 }}
        >
            <DtAlert severity="info" icon={<InfoOutlined />}>
                Select one or more configuration IDs to display.
            </DtAlert>
            {configurationIds.length === 0 ? (
                <Typography color="text.secondary" sx={{ py: 2 }}>
                    No Configuration IDs configured.
                </Typography>
            ) : (
                configurationIds.map((entry, index) => (
                    <Box
                        key={entry.Id}
                        sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 0.75 }}
                    >
                        <Checkbox
                            checked={entry.Enabled}
                            onChange={() => handleEnabledToggle(index)}
                        />
                        <Typography sx={{ fontWeight: 600, minWidth: 160 }}>{entry.Id}</Typography>
                        <TextField
                            size="small"
                            value={entry.Alias}
                            onChange={(e) => handleAliasChange(index, e.target.value)}
                            sx={{ ml: 'auto' }}
                        />
                    </Box>
                ))
            )}
        </DtCard>
    );
};

export default ConfigurationIdsTab;
